import type { Namespace } from './types';
export const zh: Namespace = {
  steamOrders: {
    title: '订单',
    empty: '没有符合条件的订单账号',
    amount: {
      unset: '未定',
    },
    actions: {
      redeem: '兑换',
      history: '历史',
      refresh: '更新',
      refreshConfirm: '更新这个账号？',
      verify: '验证',
      delete: '删除',
      grant: '授权',
      changePassword: '改密',
      // 写操作的结果提示（2026-10-23 补：写请求成功后必须给用户一个回执，
      // 否则「点了没反应」与「没点上」分不开）。
      deleted: '已删除',
      remarkSaved: '备注已保存',
      amountSaved: '面额已更新',
    },
    modal: {
      loginTitle: '登录',
      emailCode: '邮箱验证码',
      twofactorCode: '令牌验证码',
      codePlaceholder: '输入验证码',
      passwordTitle: '编辑密码',
      password: '新密码',
      passwordPlaceholder: '输入新密码',
    },
    notice: {
      loginAccepted: '已提交（{{outcome}}）',
      passwordChanged: '密码已更新',
      refreshAllAccepted: '已派发更新，结果稍后刷新查看',
    },
    search: {
      orderNo: '订单号',
      username: 'Steam 账号',
      cdkey: 'CDKey',
      remark: '备注',
    },
    fields: {
      orderNo: '订单号',
      username: '账号',
      state: '会话态',
      loginStage: '登录阶段',
      region: '地区',
      currency: '货币',
      expected: '需充金额',
      delta: '已充金额',
      card: '已充面额',
      remark: '备注',
      updatedAt: '更新时间',
      createdAt: '创建时间',
    },
    kpi: {
      orderCount: '订单数',
      accountCount: '账号数',
      states: '会话态',
      stages: '登录阶段',
    },
    create: {
      trigger: '新增订单',
      title: '新增订单',
      tabSingle: '单个账号',
      tabBatch: '批量账号',
      username: '账号',
      usernameRequired: '请填账号',
      password: '密码',
      passwordRequired: '请填密码',
      twofactor: '手机令牌（选填）',
      amount: '需充金额（选填，留空 = 未定）',
      amountPlaceholder: '0',
      remark: '备注（选填）',
      submit: '创建',
      success: '订单已创建',
      importMaFile: '导入 maFile',
      maFileImported:
        '已导入 {{imported}} 个共享密钥，匹配 {{matched}} 行（未匹配 {{unmatched}} 个）',
      maFileInvalid: '{{count}} 个文件不是可用的 maFile：{{files}}',
    },
    maFile: {
      notJson: '不是 JSON 文件',
      notObject: '不是 maFile 的对象形状',
      noAccountName: '缺少 account_name',
      noSharedSecret: '缺少合法的 shared_secret（base64 的 20 字节）',
    },
    parse: {
      hint: '每行一个账号，行内字段依次：账号 / 密码 / 需充金额 / 备注，字段间用连续短横（-- 及以上）分隔，尾部字段可省略（金额缺省记 0 USD），# 开头是注释。金额要带单位。',
      placeholder: 'alice----secret----30 EUR----VIP 客户\nbob----pass----20 CNY',
      rowCount: '共 {{count}} 行',
      validCount: '可用 {{count}} 行',
      invalidCount: '有问题 {{count}} 行',
      colUsername: '账号',
      colPassword: '密码',
      colAmount: '需充金额',
      colRemark: '备注',
      colSecret: '共享密钥',
      colStatus: '状态',
      ok: '可用',
      failed: '有问题',
      needUsername: '缺账号',
      needPassword: '缺密码',
      badAmount: '金额要带单位，如 30 USD（收到 {{unit}}）',
      badUnit: '未知币种 {{unit}}',
      tooManyFields: '字段数超了（最多 4 个：账号 / 密码 / 金额 / 备注）',
      duplicateInBatch: '本次批量里账号重复',
      secretImported: '已导入 {{count}} 个共享密钥',
      secretImportedShort: '已导入',
    },
    batch: {
      selected: '已选 {{count}} 行',
      refresh: '批量更新',
      refreshConfirm: '更新选中的 {{count}} 个账号？',
      refreshAllShort: '一键更新',
      refreshAllConfirm: '更新当前筛选下的全部 {{count}} 个账号？',
      redeem: '批量兑换',
      grant: '批量授权',
      delete: '批量删除',
      deleteConfirm: '删除选中的 {{count}} 个账号？',
    },
    rowDelete: {
      confirm: '删除订单 {{orderNo}} 上的 {{username}}？',
    },
    editAmount: {
      editHint: '点击修改需充金额',
    },
    remark: {
      editHint: '点击修改备注',
      placeholder: '备注（选填）',
    },
    redeem: {
      title: '批量兑换（{{count}} 个订单账号）',
      // 202 = **受理**（worker 还没结算）⇒ 回执不能说「已兑换」。
      accepted: '兑换已受理，结果稍后刷新查看',
      hint: '每行一个钱包码。第 N 行码给第 N 个选中的账号。',
      placeholder: 'W1-AAAA\nW1-BBBB\n# 这些是备用的',
      codeCount: '{{count}} 个码',
      pairedCount: '配对到 {{count}} 个订单账号',
      invalidCount: '{{count}} 行有问题',
      colTarget: '订单账号',
      colWalletCode: '钱包码',
      colStatus: '状态',
      ok: '可提交',
      failed: '有问题',
      needWalletCode: '这一行没填码',
      noTarget: '码比选中行多，没有归属',
      confirm: '把 {{codes}} 个钱包码提交给 {{targets}} 个订单账号？',
      submit: '提交',
    },
    refreshConfirm: {
      body: '更新这个账号？',
    },
    history: {
      tabTitle: '{{username}} 的消费历史',
      offline: '该账号无缓存会话，请先登录再查交易历史',
    },
    grant: {
      title: '授权 — {{orderNo}}',
      titleMulti: '授权 {{count}} 个账号',
      tab: {
        grant: '授权',
        revoke: '取消授权',
      },
      scopeTitle: '{{accounts}} 个账号 · {{orders}} 张订单',
      scopeList: '{{list}}',
      searchPlaceholder: '搜索用户名',
      noCandidate: '无匹配用户',
      scaleHint: '共 {{total}} 条授权',
      submit: '确认授权',
      success: '授权成功',
    },
    revoke: {
      hint: '撤销后对方立刻失去这一对账号的使用权。',
      grantee: '被授权人',
      grantedAt: '授权时间',
      actions: '操作',
      action: '撤销',
      empty: '尚未授权给任何人',
      batchHint: '一次只能撤销一个账号对。请从订单列表的行内打开。',
      never: '—',
      success: '已撤销',
    },
  },
};

export const en: Namespace = {
  steamOrders: {
    title: 'Orders',
    empty: 'No order accounts match the filters',
    amount: {
      unset: 'Not set',
    },
    actions: {
      redeem: 'Redeem',
      history: 'History',
      refresh: 'Update',
      refreshConfirm: 'Update this account?',
      verify: 'Verify',
      delete: 'Remove',
      grant: 'Grant',
      changePassword: 'Change password',
      // 写操作的结果提示（2026-10-23 补）。
      deleted: 'Removed',
      remarkSaved: 'Remark saved',
      amountSaved: 'Amount updated',
    },
    modal: {
      loginTitle: 'Sign in',
      emailCode: 'Email code',
      twofactorCode: '2FA code',
      codePlaceholder: 'Enter the code',
      passwordTitle: 'Edit password',
      password: 'New password',
      passwordPlaceholder: 'Enter the new password',
    },
    notice: {
      loginAccepted: 'Submitted ({{outcome}})',
      refreshAllAccepted: 'Update dispatched — refresh later to see the result',
      passwordChanged: 'Password updated',
    },
    search: {
      orderNo: 'Order no.',
      username: 'Steam account',
      cdkey: 'CDKey',
      remark: 'Remark',
    },
    fields: {
      orderNo: 'Order no.',
      username: 'Account',
      state: 'Session',
      loginStage: 'Login stage',
      region: 'Region',
      currency: 'Currency',
      expected: 'Expected',
      delta: 'Paid',
      card: 'Card value',
      remark: 'Note',
      updatedAt: 'Updated',
      createdAt: 'Created',
    },
    kpi: {
      orderCount: 'Orders',
      accountCount: 'Accounts',
      states: 'Session',
      stages: 'Login stage',
    },
    create: {
      trigger: 'New order',
      title: 'New order',
      tabSingle: 'Single account',
      tabBatch: 'Batch',
      username: 'Account',
      usernameRequired: 'Account is required',
      password: 'Password',
      passwordRequired: 'Password is required',
      twofactor: 'Mobile token (optional)',
      amount: 'Expected amount (optional — leave empty for “not set”)',
      amountPlaceholder: '0',
      remark: 'Note (optional)',
      submit: 'Create',
      success: 'Order created',
      importMaFile: 'Import maFile',
      maFileImported:
        'Imported {{imported}} shared secret(s), {{matched}} row(s) matched ({{unmatched}} unmatched)',
      maFileInvalid: '{{count}} file(s) are not usable maFile: {{files}}',
    },
    maFile: {
      notJson: 'Not a JSON file',
      notObject: 'Not a maFile object shape',
      noAccountName: 'Missing account_name',
      noSharedSecret: 'Missing a valid shared_secret (base64, 20 bytes)',
    },
    parse: {
      hint: 'One account per line, fields in order: account / password / expected amount / note, separated by runs of dashes (two or more); trailing fields can be omitted (a missing amount defaults to 0 USD); # starts a comment. Amounts need a unit.',
      placeholder: 'alice----secret----30 EUR----VIP\nbob----pass----20 CNY',
      rowCount: '{{count}} row(s)',
      validCount: '{{count}} usable',
      invalidCount: '{{count}} with problems',
      colUsername: 'Account',
      colPassword: 'Password',
      colAmount: 'Expected',
      colRemark: 'Note',
      colSecret: 'Secret',
      colStatus: 'Status',
      ok: 'Usable',
      failed: 'Problem',
      needUsername: 'Missing account',
      needPassword: 'Missing password',
      badAmount: 'Amount needs a unit, e.g. 30 USD (got {{unit}})',
      badUnit: 'Unknown currency {{unit}}',
      tooManyFields: 'Too many fields (max 4: account / password / amount / note)',
      duplicateInBatch: 'Duplicate account in this batch',
      secretImported: '{{count}} shared secret(s) imported',
      secretImportedShort: 'Imported',
    },
    batch: {
      selected: '{{count}} row(s) selected',
      refresh: 'Update selected',
      refreshConfirm: 'Update {{count}} selected account(s)?',
      refreshAllShort: 'Update all',
      refreshAllConfirm: 'Update all {{count}} account(s) in the current filter?',
      redeem: 'Redeem selected',
      grant: 'Grant selected',
      delete: 'Remove selected',
      deleteConfirm: 'Remove {{count}} selected account(s)?',
    },
    rowDelete: {
      confirm: 'Remove {{username}} from order {{orderNo}}?',
    },
    editAmount: {
      editHint: 'Click to edit the expected amount',
    },
    remark: {
      editHint: 'Click to edit the note',
      placeholder: 'Note (optional)',
    },
    redeem: {
      title: 'Batch redeem ({{count}} account(s))',
      // 202 = **accepted**（the worker has not settled it yet).
      accepted: 'Redeem accepted — check the refreshed list for the result',
      hint: 'One wallet code per line. Line N goes to the Nth selected account.',
      placeholder: 'W1-AAAA\nW1-BBBB\n# these are spares',
      codeCount: '{{count}} code(s)',
      pairedCount: 'paired to {{count}} account(s)',
      invalidCount: '{{count}} row(s) with problems',
      colTarget: 'Order account',
      colWalletCode: 'Wallet code',
      colStatus: 'Status',
      ok: 'Ready',
      failed: 'Problem',
      needWalletCode: 'No code on this line',
      noTarget: 'More codes than selected rows — the extras have no target',
      confirm: 'Submit {{codes}} wallet code(s) to {{targets}} account(s)?',
      submit: 'Submit',
    },
    refreshConfirm: {
      body: 'Update this account?',
    },
    history: {
      tabTitle: '{{username}} · Purchase history',
      offline: 'No cached session for this account — log in first',
    },
    grant: {
      title: 'Grant — {{orderNo}}',
      titleMulti: 'Grant {{count}} accounts',
      tab: {
        grant: 'Grant',
        revoke: 'Revoke',
      },
      scopeTitle: '{{accounts}} accounts · {{orders}} orders',
      scopeList: '{{list}}',
      searchPlaceholder: 'Search usernames',
      noCandidate: 'No matches',
      scaleHint: '{{total}} grants',
      submit: 'Confirm',
      success: 'Granted',
    },
    revoke: {
      hint: 'Revoking takes this account pair away immediately.',
      grantee: 'Grantee',
      grantedAt: 'Granted at',
      actions: 'Actions',
      action: 'Revoke',
      empty: 'Not granted to anyone yet',
      batchHint: 'One account pair at a time. Open it from a row in the order list.',
      never: '—',
      success: 'Revoked',
    },
  },
};
